export function ErrorMessage() {
  const openIntercom = () => window.Intercom?.("show");

  return (
    <span className="text-sm">
      Please{" "}
      <a className="text-text-base-active hover:text-text-base-active-hover cursor-pointer" onClick={openIntercom}>
        get in touch
      </a>{" "}
      or try again later.
    </span>
  );
}
